/**
 * File: contactForm.js.
 *
 * Import and initialize functions for Contact Form
 */

 const $ = require('jquery');

 export default {
    wpcf7Elem: document.querySelector( '.udp-wpcf7-newsletter .wpcf7' ),
	init() {
        if (this.wpcf7Elem) {
            this.render();
        }
	},
	render() {
        this.wpcf7Elem.addEventListener('wpcf7mailsent', () => {
            this.wpcf7Elem.closest(".udp-wpcf7-newsletter").classList.add("udp-wpcf7-newsletter-sent");
        }, false);
	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};